<template>
    <v-dialog v-model="showDialog" max-width="600px" persistent>
        <v-sheet
            class=" d-flex pa-4 flex-column justify-space-around align-center"
            rounded
            style="position: relative">
            <v-btn absolute icon right top @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <div class="d-flex flex-column mb-4">
                <h3>Qrcode</h3>
                <div> serverAddress : {{ data.serverAddress }}</div>
                <div> environment_type : {{ data.environment_type }}</div>
            </div>
            <qrcode-vue :value="qrcodeData" level="H" size="300"/>
            <hr>
        </v-sheet>
    </v-dialog>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
    name: "Qrcode",
    components: {
        QrcodeVue
    },
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            data: {
                serverAddress: process.env.MIX_QR_CODE_URL,
                environment_type: process.env.MIX_QR_CODE_ENV
            }
        }
    },
    computed: {
        showDialog: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
        qrcodeData() {
            return JSON.stringify(this.data)
        }
    },
    mounted() {
        console.info(process.env.MIX_QR_CODE_URL)
        console.info(process.env.MIX_QR_CODE_ENV)
    },
}
</script>

<style scoped>

</style>
